var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnOtherBlockLink = function SvgIcnOtherBlockLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4714 1.52864C14.7318 1.78899 14.7318 2.2111 14.4714 2.47145L9.13807 7.80478C8.87772 8.06513 8.45561 8.06513 8.19526 7.80478C7.93491 7.54443 7.93491 7.12232 8.19526 6.86197L13.5286 1.52864C13.7889 1.26829 14.2111 1.26829 14.4714 1.52864Z",
    fill: "#7E8185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 2.00004C10.667 1.63185 10.9655 1.33337 11.3337 1.33337H14.0003C14.3685 1.33337 14.667 1.63185 14.667 2.00004V5.33337C14.667 5.70156 14.3685 6.00004 14.0003 6.00004C13.6321 6.00004 13.3337 5.70156 13.3337 5.33337V2.66671H11.3337C10.9655 2.66671 10.667 2.36823 10.667 2.00004Z",
    fill: "#7E8185"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50327 2.50364C3.36446 1.64244 4.63392 1.33337 6.19967 1.33337H7.39967C7.76786 1.33337 8.06634 1.63185 8.06634 2.00004C8.06634 2.36823 7.76786 2.66671 7.39967 2.66671H6.19967C4.76543 2.66671 3.93488 2.95764 3.44608 3.44645C2.95727 3.93525 2.66634 4.76579 2.66634 6.20004V9.80004C2.66634 11.2343 2.95727 12.0648 3.44608 12.5536C3.93488 13.0424 4.76543 13.3334 6.19967 13.3334H9.79967C11.2339 13.3334 12.0645 13.0424 12.5533 12.5536C13.0421 12.0648 13.333 11.2343 13.333 9.80004V8.60004C13.333 8.23185 13.6315 7.93337 13.9997 7.93337C14.3679 7.93337 14.6663 8.23185 14.6663 8.60004V9.80004C14.6663 11.3658 14.3573 12.6353 13.4961 13.4964C12.6349 14.3576 11.3654 14.6667 9.79967 14.6667H6.19967C4.63392 14.6667 3.36446 14.3576 2.50327 13.4964C1.64208 12.6353 1.33301 11.3658 1.33301 9.80004V6.20004C1.33301 4.63429 1.64208 3.36483 2.50327 2.50364Z",
    fill: "#7E8185"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnOtherBlockLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_other_block_link.2c2db7bb.svg";
export { ForwardRef as ReactComponent };